// extracted by mini-css-extract-plugin
export default {"form":"TranslateFeedbackHistoryForm_form__MU1KA","form-group":"TranslateFeedbackHistoryForm_form-group__d1jnC"};